document.querySelector( '.announcement-bar__close' ).addEventListener( 'click', () => {
    if ( themeObject.headerDiv ) {
        themeObject.headerDiv.style.top = "";
    }
});
